import React from "react";
import {Admin, Resource, Delete} from "admin-on-rest";
import restClient from "./restClient";
import {
  PartnerList,
  PartnerEdit,
  PartnerCreate,
  PartnerDelete
} from "./containers/CRM/Partners/";
import {
  AdminList,
  AdminCreate,
  AdminEdit,
  AdminDelete
} from "./containers/CRM/Admins/";
import {
  StoreList,
  StoreEdit,
  StoreCreate,
  StoreDelete
} from "./containers/CRM/Stores/";
import {
  RegionList,
  RegionCreate,
  RegionEdit,
} from "./containers/CRM/Regions/";
import {
  StoreMessageList,
  StoreMessageShow,
  StoreMessageEdit,
  StoreMessageCreate
} from "./containers/CRM/StoreMessages/";
import {
  MarketingPartnerList,
  MarketingPartnerEdit,
} from "./containers/CRM/MarketingPartners/";
import {
  MessageTemplateList,
  MessageTemplateEdit
} from "./containers/CRM/MessageTemplates/";
import {
  CustomerList,
  CustomerCreate,
  CustomerDelete
} from "./containers/CRM/Customers/";
import {
  SuppressionsList,
  SuppressionsDelete
} from "./containers/CRM/Suppressions/";
import {
  VirtualSlipCrmList,
  VirtualSlipCrmCreate,
  VirtualSlipCrmEdit,
  VirtualSlipDelete
} from "./containers/CRM/VirtualSlips/";
import {
  PromoList,
  PromoShow,
  PromoCreate,
  PromoEdit,
  PromoDelete
} from "./containers/CRM/Promos/";
import {
  GameTipList,
  GameTipCreate,
  GameTipEdit,
  GameTipShow
} from "./containers/CRM/GameTips/";
import {
  ReportsList
} from "./containers/CRM/DataReports";
import {
  CustomerAnalyticsList,
  GiftCardsAnalyticsList,
  CustomerPhonesAnalyticsList,
  CustomerEmailsAnalyticsList,
  CashbackerCampaignRegistrationsAnalyticsList
} from "./containers/CRM/AnalyticsData";
import {
  DeviceList, 
  DeviceShow,
  DeviceEdit
} from "./containers/CRM/Devices/";
import {NotFound} from "./containers/NotFound";
import configuration from "./reducers/configuration";
import {saveConfiguration as saveConfigurationAction} from "./actions/saveConfiguration";
import images from "./reducers/images";
import {getImagesSuccess as getImagesSuccessAction} from "./actions/images";
import giftCards from "./reducers/giftCards";
import {giftCardsEnabled as giftCardsEnabledAction} from "./actions/giftCards";
import "./App.css";
import Layout from "./components/Layout/";
import Login from "./containers/Login/";
import Menu from "./components/Menu/";
import {Dashboard} from "./containers/Dashboard";
import authClient from "./authClient";
import customRoutes from "./customRoutes";
import LogoutButton from "./components/LogoutButton";

import {
  GiftCardList,
  GiftCardEdit,
  GiftCardCreate,
  GiftCardDelete
} from "./containers/CRM/GiftCards";

import errorSagas from './sagas/errorSagas';

import {messages} from './AppMessages';

const title = "BE Blue";

const App = () => {  
  return (
    <Admin
      customSagas={[ errorSagas ]}
      title={title}
      catchAll={NotFound}
      appLayout={Layout}
      loginPage={Login}
      authClient={authClient}
      menu={Menu}
      dashboard={Dashboard}
      restClient={restClient}
      customRoutes={customRoutes}
      logoutButton={LogoutButton}
      customReducers={{configuration, images, giftCards }}
      customActions={{saveConfigurationAction, getImagesSuccessAction, giftCardsEnabledAction}}
      locale="sv"
      messages={messages}
    >
      {permissions => {
        if(permissions === "admin"){
          return [
            <Resource
              name="partners"
              list={PartnerList}
              edit={PartnerEdit}
              create={PartnerCreate}
              remove={PartnerDelete}
            />,
            <Resource
              name="admins"
              list={AdminList}
              create={AdminCreate}
              edit={AdminEdit}
              remove={AdminDelete}
            />,
            <Resource
              name="kiosks"
              list={StoreList}
              edit={StoreEdit}
              create={StoreCreate}
              remove={StoreDelete}
            />,
            <Resource
              name="regions"
              list={RegionList}
              create={RegionCreate}
              edit={RegionEdit}
            />,
            <Resource
              name="marketing_partners"
              list={MarketingPartnerList}
              edit={MarketingPartnerEdit}
            />,
            <Resource
              name="customers"
              list={CustomerList}
              create={CustomerCreate}
              remove={CustomerDelete}
            />,
            <Resource
              name="suppressions"
              list={SuppressionsList}
              remove={SuppressionsDelete}
            />,
            <Resource name="preview" />,
            <Resource name="tags" />,
            <Resource
              name="speltips"
              list={GameTipList}
              create={GameTipCreate}
              edit={GameTipEdit}
              show={GameTipShow}
            />,
            <Resource
              name="virtualslips"
              list={VirtualSlipCrmList}
              edit={VirtualSlipCrmEdit}
              create={VirtualSlipCrmCreate}
              remove={VirtualSlipDelete}
            />,
            <Resource
              name="promos"
              list={PromoList}
              show={PromoShow}
              edit={PromoEdit}
              create={PromoCreate}
              remove={PromoDelete}
            />,
            <Resource
              name="store_messages"
              list={StoreMessageList}
              show={StoreMessageShow}
              edit={StoreMessageEdit}
              create={StoreMessageCreate}
            />,
            <Resource
              name="message_templates"
              list={MessageTemplateList}
              edit={MessageTemplateEdit}
            />,
            <Resource 
              name="devices" 
              list={DeviceList} 
              show={DeviceShow} 
              edit={DeviceEdit}
            />,
            <Resource name="reports" list={ReportsList} />,
            <Resource name="reporting/customer_registration" list={CustomerAnalyticsList} />,
            <Resource name="reporting/gift_cards" list={GiftCardsAnalyticsList} />,
            <Resource name="reporting/all_customer_phones" list={CustomerPhonesAnalyticsList} />,
            <Resource name="reporting/all_customer_emails" list={CustomerEmailsAnalyticsList} />,
            <Resource name="reporting/cashbacker_campaign_registrations" list={CashbackerCampaignRegistrationsAnalyticsList} />,
            <Resource name="industries" />,
            <Resource name="boosts" />
          ]
        } else if(permissions === "partner"){
          return [
            <Resource
              name="gift_cards"
              list={GiftCardList}
              edit={GiftCardEdit}
              create={GiftCardCreate}
              remove={GiftCardDelete}
            />
          ]
        } else return [];
      }}
    </Admin>
  )
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js